export default __webpack_public_path__ + "assets/images/170745f4d08008043ffed589620109c2.png";